import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet
} from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';

import Dashboard from './pages/Dashboard';
import AtendimentoDeheus01 from './pages/DeHeus/AtendimentoMotorista/AtendimentoDeheus01';
import AtendimentoDeheus02 from './pages/DeHeus/AtendimentoMotorista/AtendimentoDeheus02';
//import DashboardPage from './pages/DashboardPage';

import NotFoundPage from './pages/NotFoundPage';
import HomeDriver from './pages/Motoristas/HomeDriver';
import HomeVisitas from './pages/Visitas/HomeVisitas';

// VISITAS
import VisitasLiberadas from './pages/Visitas/VisitasLiberadas';
import VisitaAguardandoLiberacao from './pages/Visitas/VisitaAguardandoLiberacao';
import VisitaAguardandoAgendamento from './pages/Visitas/VisitaAguardandoAgendamento';
import VisitaFinalizada from './pages/Visitas/VisitaFinalizada';
import HomeConfig from './pages/Config/HomeConfig';
import ConfigFormulario from './pages/Config/ConfigFormulario';
import AuditarVisita from './pages/Config/AuditarVisita';
import EditarVisita from './pages/Config/EditarVisita';
import DeheusForm from './pages/formulario/DeheusForm';
import VisitaCarregamento from './pages/Visitas/VisitaCarregamento';
import VisitaDescarregamento from './pages/Visitas/VisitaDescarregamento';


const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to='/login' />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/Atendimento/DeHeus01' element={<AtendimentoDeheus01 />} />
        <Route path='/Atendimento/DeHeus02' element={<AtendimentoDeheus02 />} />
        <Route path='/Atendimento/Formulario' element={<DeheusForm />} />

        {/* Rotas protegidas */}
        <Route element={<ProtectedRoute><Outlet /></ProtectedRoute>}>
          <Route path='/dashboard' element={<Dashboard />} />

          {/* Rota pai para visitas */}
          <Route path='/ConsultarVisitas' element={<HomeVisitas />}>
            <Route index element={<VisitasLiberadas />} /> {/* Rota padrão */}

            <Route path='carregamento' element={<VisitaCarregamento />} />
            <Route path='descarregamento' element={<VisitaDescarregamento />} />

            <Route path='liberadas' element={<VisitasLiberadas />} />
            <Route path='agendadas' element={<VisitaAguardandoLiberacao />} />
            <Route path='aguardando' element={<VisitaAguardandoAgendamento />} />
            <Route path='finalizar' element={<VisitaFinalizada />} />
            {/* Adicione outras sub-rotas aqui */}
          </Route>

          <Route path='/ConsultarMotoristas' element={<HomeDriver />} />


          <Route path='/Configuracoes' element={<HomeConfig />}>
            <Route index element={<AuditarVisita />} /> {/* Rota padrão */}
            <Route path='visitas' element={<AuditarVisita />} />
             <Route path='formulario' element={<ConfigFormulario />} />
             <Route path='editar' element={<EditarVisita />} />

          </Route>

          <Route path='/' element={<Navigate to='/Dashboard' />} />
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;